import React, { useState, useCallback, useEffect } from 'react';
import MainMenu from './components/MainMenu';
import TeamSelect from './components/TeamSelect';
import Tournament from './components/Tournament';
import Game from './components/Game';
import './styles/App.css';

export default function App() {
  const [screen, setScreen] = useState('boot');
  const [role, setRole] = useState(null);
  const [gameMode, setGameMode] = useState(null); // friendly | tournament | twoPlayer
  const [homeTeam, setHomeTeam] = useState(null);
  const [awayTeam, setAwayTeam] = useState(null);
  const [matchResultCallback, setMatchResultCallback] = useState(null);

  const handleTwoPlayerSelect = () => {
    setRole('player');
    setScreen('teamSelect');
    setGameMode('twoPlayer');
  };

  // PS Boot ekranı - 3 saniye göster
  useEffect(() => {
    const timer = setTimeout(() => setScreen('menu'), 3000);
    return () => clearTimeout(timer);
  }, []);

  const handleRoleSelect = (selectedRole) => {
    setRole(selectedRole);
    setScreen('teamSelect');
    setGameMode('friendly');
  };

  const handleTournamentSelect = (selectedRole) => {
    setRole(selectedRole);
    setScreen('teamSelect');
    setGameMode('tournament');
  };

  const handleTeamsSelected = (home, away) => {
    if (gameMode === 'tournament') {
      setHomeTeam(home);
      setScreen('tournamentBracket');
    } else {
      setHomeTeam(home);
      setAwayTeam(away);
      setScreen('playing');
    }
  };

  const handleTournamentMatch = useCallback((home, away, resultCb) => {
    setHomeTeam(home);
    setAwayTeam(away);
    setMatchResultCallback(() => resultCb);
    setScreen('playing');
  }, []);

  const handleMatchEnd = useCallback((homeScore, awayScore) => {
    if (matchResultCallback) {
      matchResultCallback(homeScore, awayScore);
      setMatchResultCallback(null);
    }
    if (gameMode === 'tournament') {
      setScreen('tournamentBracket');
    } else {
      setScreen('teamSelect');
    }
  }, [matchResultCallback, gameMode]);

  const backToMenu = () => {
    setScreen('menu');
    setRole(null);
    setHomeTeam(null);
    setAwayTeam(null);
    setGameMode(null);
    setMatchResultCallback(null);
  };

  const backToTeamSelect = () => {
    if (gameMode === 'tournament') {
      setScreen('tournamentBracket');
    } else {
      setScreen('teamSelect');
    }
  };

  return (
    <div className="app">
      {screen === 'boot' && (
        <div className="ps-boot-screen">
          <div className="ps-boot-logo">
            <div className="ps-boot-symbols">
              <span className="ps-boot-sym" style={{color:'#00d4aa'}}>△</span>
              <span className="ps-boot-sym" style={{color:'#ff4455'}}>○</span>
              <span className="ps-boot-sym" style={{color:'#5599ff'}}>✕</span>
              <span className="ps-boot-sym" style={{color:'#ee77aa'}}>□</span>
            </div>
            <div className="ps-boot-text">PlayStation Edition</div>
            <div className="ps-boot-bar"><div className="ps-boot-bar-fill" /></div>
          </div>
        </div>
      )}
      {screen === 'menu' && (
        <MainMenu
          onStart={handleRoleSelect}
          onTournament={handleTournamentSelect}
          onTwoPlayer={handleTwoPlayerSelect}
        />
      )}
      {screen === 'teamSelect' && (
        <TeamSelect
          onBack={backToMenu}
          onStart={handleTeamsSelected}
          singleSelect={gameMode === 'tournament'}
        />
      )}
      {screen === 'tournamentBracket' && homeTeam && (
        <Tournament
          userTeam={homeTeam}
          role={role}
          onStartMatch={handleTournamentMatch}
          onBack={backToMenu}
        />
      )}
      {screen === 'playing' && (
        <Game
          role={role}
          homeTeam={homeTeam}
          awayTeam={awayTeam}
          twoPlayer={gameMode === 'twoPlayer'}
          onBack={backToTeamSelect}
          onMatchEnd={gameMode === 'tournament' ? handleMatchEnd : null}
        />
      )}
    </div>
  );
}
